import React from "react";

import { useTheme } from "@emotion/react";
import { Dialog, DialogContent, DialogTitle, Box } from "@mui/material";

import ActionButton from "components/styled/ActionButton";
import PropTypes from "prop-types";

function WhatsNextDialog({ handleClose, open }) {
  const mainTheme = useTheme();

  return (
    <Dialog onClose={handleClose} open={open}>
      <Box
        sx={{
          bgcolor: mainTheme.palette.blackSecondary.main,
          textAlign: "center",
        }}
      >
        <DialogTitle>Thanks for downloading your COMP Score!</DialogTitle>
        <DialogContent>
          <ActionButton
            href="https://compinitiative.com/after-the-score"
            sx={{
              bgcolor: mainTheme.palette.darkPurplePrimary.main,
            }}
          >
            Now What?
          </ActionButton>
        </DialogContent>
      </Box>
    </Dialog>
  );
}

WhatsNextDialog.propTypes = {
  handleClose: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
};

export default WhatsNextDialog;
